import { IOrderStatusBody } from "../../../interfaces/IOrderStatus";
import { generateQRCodeURL } from "../../../services/generateConsumerURLs";
import { IProcessedOrders } from "../constants";



export function readyForCollectionTransform(orderList: IProcessedOrders[]) {
    const body: IOrderStatusBody[] = [];
    for (const item of orderList) {
        if (item.order_status === "ACCEPTED" && item.collection_point_id !== null) {
            body.push({
                placed_order_id: item.id,
                new_status: "READY_FOR_COLLECTION",
                template_placeholders: {
                    placed_order_hash_id: item.hash_id,
                    qr_access_code_url: generateQRCodeURL(item.id)
                }
            });
        }
    }
    return body;
}

export function finishAllTransform(orderList: IProcessedOrders[]) {
    return orderList.map((order) => {
        return {
            placed_order_id: order.id,
            new_status: "FINISHED",
        }
    });
}

